import request from '@/utils/request';
import { BASE_URL } from '@/utils/global';

// 第三方授权
export function thirdpartyAuthorize(data: any) {
  return request({
    url: `${BASE_URL.scmServer}/api/thirdparty/auth/authorize.ac`,
    method: 'post',
    data,
  });
}

// 取消授权
export function thirdpartyCancelAuthorize(data: any) {
  return request({
    url: `${BASE_URL.scmServer}/api/thirdparty/auth/cancelAuthorize.ac`,
    method: 'post',
    data,
  });
}

// 第三方授权信息列表
export function thirdpartList(data: any = {}) {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/thirdpart/manager/list.ac`,
    method: 'post',
    data,
  });
}

// 同步JST仓库
export function syncWarehouse() {
  return request({
    url: `${BASE_URL.scmServer}/api/thirdparty/jushuitan/warehouse/syncWarehouse.ac`,
    method: 'post',
  });
}

// 按款查询聚水潭商品信息
export function getGoodsListByJst(data: any = {}) {
  return request({
    url: `${BASE_URL.scmServer}/api/thirdparty/jushuitan/goods/getGoodsList.ac`,
    method: 'post',
    data,
  });
}

// 同步商品 聚水潭 to 生产系统
export function synJstGoodsToScm(data: any = {}) {
  return request({
    url: `${BASE_URL.scmServer}/api/thirdparty/jushuitan/goods/synJstGoodsToScm.ac`,
    method: 'post',
    data,
  });
}

// 同步商品 生产系统 to 聚水潭
export function synScmGoodsToJst(data: any = {}) {
  return request({
    url: `${BASE_URL.scmServer}/api/thirdparty/jushuitan/goods/synScmGoodsToJst.ac`,
    method: 'post',
    data,
  });
}

// 同步商品 同步商品信息
export function synSingleGoods(params: any = {}) {
  return request({
    url: `${BASE_URL.scmServer}/api/thirdparty/jushuitan/goods/synSingleGoods.ac`,
    method: 'post',
    params,
  });
}

// scm供应商上传到聚水潭
export function jstUploadScmSupplier(data: any) {
  return request({
    url: `${BASE_URL.scmServer}/api/thirdparty/jushuitan/purchase/supplier/jstUploadScm.ac`,
    method: 'post',
    data,
  });
}

// scm供应商上传到聚水潭
export function scmUploadJstSupplier(data: any) {
  return request({
    url: `${BASE_URL.scmServer}/api/thirdparty/jushuitan/purchase/supplier/scmUploadJst.ac`,
    method: 'post',
    data,
  });
}

// 聚水潭供应商信息同步scm | scm供应商信息同步聚水潭
export function syncSingleSupplier(data: any) {
  return request({
    url: `${BASE_URL.scmServer}/api/thirdparty/jushuitan/purchase/supplier/sync.ac`,
    method: 'post',
    data,
  });
}

// 标记聚水潭自有工厂
export function markAloneProduce(data: any) {
  return request({
    url: `${BASE_URL.scmServer}/api/thirdparty/jushuitan/purchase/supplier/markAloneProduce.ac`,
    method: 'post',
    data,
  });
}

// 取消标记聚水潭自有工厂
export function cancelMarkAloneProduce(data: any) {
  return request({
    url: `${BASE_URL.scmServer}/api/thirdparty/jushuitan/purchase/supplier/markAloneProduce/cancel.ac`,
    method: 'post',
    data,
  });
}

// 查询同步日志
export function syncLogList(data: any) {
  return request({
    url: `${BASE_URL.scmServer}/api/thirdparty/sync/log/page.ac`,
    method: 'post',
    data,
  });
}
// 手动同步
export function manualSyncing(data: any) {
  return request({
    url: `${BASE_URL.scmServer}/api/thirdparty/sync/manualSyncing.ac`,
    method: 'post',
    data,
  });
}

// 快麦授权
export function kuaimaiAuthorize(data: any) {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/oauth/kuaimai/add.ac`,
    method: 'post',
    data,
  });
}

// 快麦-下载快麦商品
export function loadKMGoods(data: any) {
  return request({
    url: `${BASE_URL.scmServer}/api/thirdparty/kuaimai/goods/sse/loadGoods.ac`,
    method: 'post',
    data,
  });
}

// 快麦-获取上次快麦商品下载时间
export function getLoadGoodsLastExecuteTime() {
  return request({
    url: `${BASE_URL.scmServer}/api/thirdparty/kuaimai/goods/getLoadGoodsLastExecuteTime.ac`,
    method: 'post',
    data: {},
  });
}

// 快麦：获取商品列表
export function getGoodsListByKM(data: any) {
  return request({
    url: `${BASE_URL.scmServer}/api/thirdparty/kuaimai/goods/queryList.ac`,
    method: 'post',
    data,
  });
}

// 快麦-按SCM同步商品
export function syncGoodsByKM(data: any) {
  return request({
    url: `${BASE_URL.scmServer}/api/thirdparty/kuaimai/goods/sync/syncGoods.ac`,
    method: 'post',
    data,
  });
}

// 快麦-按SCM同步供应商
export function syncSupplierByScm(data: any) {
  return request({
    url: `${BASE_URL.scmServer}/api/thirdparty/kuaimai/purchase/supplier/syncSupplierByScm.ac`,
    method: 'post',
    data,
  });
}

// 快麦-按快麦同步供应商、导入供应商
export function syncSupplierByKm(data: any) {
  return request({
    url: `${BASE_URL.scmServer}/api/thirdparty/kuaimai/purchase/supplier/syncSupplierByKm.ac`,
    method: 'post',
    data,
  });
}

// 快麦-快麦供应商列表
export function queryKmSupplierList(data: any) {
  return request({
    url: `${BASE_URL.scmServer}/api/thirdparty/kuaimai/purchase/supplier/queryKmSupplierList.ac`,
    method: 'post',
    data,
  });
}
/* // 快麦-导入供应商
export function importKMSupplier(data: any) {
  return request({
    url: `${BASE_URL.scmServer}/api/thirdparty/kuaimai/purchase/supplier/importSupplier.ac`,
    method: 'post',
    data,
  });
}
 */
// 快麦-标记自主生产供应商
export function markHouseProduce(data: any) {
  return request({
    url: `${BASE_URL.scmServer}/api/thirdparty/kuaimai/purchase/supplier/markHouseProduce.ac`,
    method: 'post',
    data,
  });
}

// 快麦-取消标记自主生产供应商
export function cancelMarkHouseProduce(data: any) {
  return request({
    url: `${BASE_URL.scmServer}/api/thirdparty/kuaimai/purchase/supplier/cancelMarkHouseProduce.ac`,
    method: 'post',
    data,
  });
}

// 快麦-同步快麦仓库
export function syncWarehouseByKm() {
  return request({
    url: `${BASE_URL.scmServer}/api/thirdparty/kuaimai/warehouse/syncWarehouse.ac`,
    method: 'post',
  });
}

// 快麦-下载商品
export function loadGoods(data: any) {
  return request({
    url: `${BASE_URL.scmServer}/api/thirdparty/kuaimai/goods/loadGoods.ac`,
    method: 'post',
    data,
  });
}

// 查询线上订单号和付款日期
export function getOnlineSnAndPayTime(data: any) {
  return request({
    url: `${BASE_URL.scmServer}/api/thirdparty/jushuitan/purchase/getOnlineSnAndPayTime.ac`,
    method: 'post',
    data,
    noErrorToast: true,
  });
}

// 同步分类信息到生产系统
export function syncCategoryToScm() {
  return request({
    url: `${BASE_URL.scmServer}/api/thirdparty/jushuitan/category/syncToScm.ac`,
    method: 'post',
  });
}

// 同步分类信息到聚水潭
export function syncCategoryToJst() {
  return request({
    url: `${BASE_URL.scmServer}/api/thirdparty/jushuitan/category/syncToJst.ac`,
    method: 'post',
  });
}
